import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import './BlogDetail.css';

export default function BlogDetail() {
  const { slug } = useParams();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`/api/blogs/${slug}`)
      .then(r => { setBlog(r.data); setLoading(false); })
      .catch(() => setLoading(false));
    window.scrollTo(0, 0);
  }, [slug]);

  if (loading) return (
    <div className="blog-detail-page" style={{ paddingTop: 120, textAlign: 'center' }}>
      <div className="loading-spinner" />
    </div>
  );

  if (!blog) return (
    <div className="blog-detail-page" style={{ paddingTop: 120, textAlign: 'center' }}>
      <div style={{ padding: '80px 20px' }}>
        <div style={{ fontSize: '3rem', marginBottom: '16px' }}>😕</div>
        <h2 style={{ color: 'var(--navy)', marginBottom: '12px' }}>ब्लॉग नहीं मिला</h2>
        <Link to="/blogs" className="btn-primary">← सभी ब्लॉग देखें</Link>
      </div>
    </div>
  );

  return (
    <div className="blog-detail-page">
      <div className="blog-detail-hero">
        <div className="container">
          <Link to="/blogs" className="blog-back">← वापस जाएं</Link>
          <span className="section-label">{blog.category}</span>
          <h1>{blog.title}</h1>
          <div className="blog-detail-meta">
            <span>✍️ {blog.author}</span>
            <span>📅 {new Date(blog.created_at).toLocaleDateString('hi-IN', { year: 'numeric', month: 'long', day: 'numeric' })}</span>
          </div>
        </div>
      </div>

      <div className="blog-detail-body">
        <div className="container">
          <div className="blog-detail-layout">
            <article className="blog-article">
              {blog.image_url && (
                <div className="blog-detail-img">
                  <img src={`http://localhost:5000${blog.image_url}`} alt={blog.title} />
                </div>
              )}
              <div className="blog-content" dangerouslySetInnerHTML={{ __html: blog.content }} />
            </article>

            <aside className="blog-sidebar">
              <div className="sidebar-cta">
                <h3>परामर्श लें</h3>
                <p>महिला स्वास्थ्य से जुड़ी किसी भी समस्या के लिए</p>
                <a href="https://wa.me/+918796769013" target="_blank" rel="noreferrer" className="btn-whatsapp" style={{ width: '100%', justifyContent: 'center', marginBottom: '10px', display: 'flex' }}>
                  💬 WhatsApp करें
                </a>
                <a href="tel:+91879676" className="btn-navy" style={{ width: '100%', justifyContent: 'center', display: 'flex' }}>
                  📞 Call करें
                </a>
              </div>

              <div className="sidebar-disclaimer">
                <span>⚠️</span>
                <p>यह लेख केवल जानकारी के लिए है। किसी भी समस्या के लिए विशेषज्ञ से सलाह लें।</p>
              </div>
            </aside>
          </div>
        </div>
      </div>
    </div>
  );
}
